import { render, staticRenderFns } from "./ReferenceCardListSkeletonLoader.vue?vue&type=template&id=6b792ced&scoped=true&"
import script from "./ReferenceCardListSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./ReferenceCardListSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCardListSkeletonLoader.vue?vue&type=style&index=0&id=6b792ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b792ced",
  null
  
)

export default component.exports